<template>
  <CompText
    v-if="form.input_type == 'text'"
    :id="form.id"
    :itemName="form.input_question"
    inputQuestion=""
    :description="form.input_note"
    :rules="form.input_validation_rule || ''"
    :unit="form.unit"
    :placeholder="form.input_example"
    v-model:inputValue="state.inputDataModel[form.id]"
    :dataType="form.data_type"
    :disabled="publishRequestedExists === 1"
    :isSubmit="isSubmit"
    :index="index"
  ></CompText>

  <CompTextArea
    v-if="form.input_type == 'textarea'"
    :id="form.id"
    :itemName="form.input_question"
    inputQuestion=""
    :description="form.input_note"
    :rules="form.input_validation_rule || ''"
    :placeholder="form.input_example"
    v-model:inputValue="state.inputDataModel[form.id]"
    :dataType="form.data_type"
    :disabled="publishRequestedExists === 1"
    :isSubmit="isSubmit"
    :index="index"
  ></CompTextArea>

  <CompSelectRadio
    v-if="form.input_type == 'select'"
    :id="form.id + 'index' + index"
    :itemName="form.input_question"
    inputQuestion=""
    :description="form.input_note"
    :rules="form.input_validation_rule || ''"
    :unit="form.unit"
    :items="form.options"
    v-model:inputValue="state.inputDataModel[form.id]"
    :dataType="form.data_type"
    :disabled="publishRequestedExists === 1"
    :isSubmit="isSubmit"
    :index="index"
  ></CompSelectRadio>

  <CompRadio
    v-if="form.input_type == 'radio'"
    :id="form.id"
    :itemName="form.input_question"
    inputQuestion=""
    :description="form.input_note"
    :rules="form.input_validation_rule || ''"
    :items="form.options"
    v-model:inputValue="state.inputDataModel[form.id]"
    :dataType="form.data_type"
    :disabled="publishRequestedExists === 1"
    :isSubmit="isSubmit"
    :index="index"
  ></CompRadio>

  <CompCheckbox
    v-if="form.input_type == 'checkbox'"
    :id="form.id"
    :itemName="form.input_question"
    inputQuestion=""
    :description="form.input_note"
    :rules="form.input_validation_rule || ''"
    :items="form.options"
    v-model:inputValue="state.inputDataModel[form.id]"
    :dataType="form.data_type"
    :disabled="publishRequestedExists === 1"
    :isSubmit="isSubmit"
    :index="index"
  ></CompCheckbox>

  <CompDatepicker
    v-if="form.input_type == 'date'"
    :id="form.id"
    :itemName="form.input_question"
    inputQuestion=""
    :description="form.input_note"
    :rules="form.input_validation_rule || ''"
    v-model:inputValue="state.inputDataModel[form.id]"
    :dataType="form.data_type"
    :disabled="publishRequestedExists === 1"
    :isSubmit="isSubmit"
    :index="index"
  ></CompDatepicker>
</template>

<script>
import { computed, reactive } from 'vue';
import CompText from '@/components/form/CompText';
import CompTextArea from '@/components/form/CompTextArea';
import CompRadio from '@/components/form/CompRadio';
import CompCheckbox from '@/components/form/CompCheckbox';
import CompSelectRadio from '@/components/form/CompSelectRadio';
import CompDatepicker from '@/components/form/CompDatepicker';

export default {
  props: ['inputData', 'form', 'publishRequestedExists', 'isSubmit', 'index'], // inputオブジェクト, APIから取得しているプロパティ
  components: {
    CompText,
    CompTextArea,
    CompRadio,
    CompCheckbox,
    CompSelectRadio,
    CompDatepicker,
  },
  setup(props) {
    const state = reactive({
      inputDataModel: computed(() => {
        return props.inputData;
      }),
    });
    return {
      state,
    };
  },
};
</script>
